import React from "react";
import { Order } from "@/api/models/api-types";
import { OrderMerchantSection } from "../components/OrderMerchantSection";

interface OrderItemsSectionProps {
  orders: Order[];
}

export const OrderItemsSection: React.FC<OrderItemsSectionProps> = ({
  orders,
}) => {
  return (
    <div className="border border-[#e3e8ef] dark:border-gray-700 rounded-[12px] overflow-hidden">
      <div className="p-4 md:p-6 space-y-4 md:space-y-6">
        {orders.map((order, index) => (
          <div key={order._id}>
            <OrderMerchantSection order={order} />
            {index < orders.length - 1 && (
              <div className="h-px bg-[#e3e8ef] dark:bg-gray-700 my-4 md:my-6" />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
